module.exports = __webpack_public_path__ + "img/logo-wrapper.38f47979.png";